import styled from 'styled-components'

export const EmojiWrapper = styled.div`
  display: flex;
  width: 35px;
  height: 35px;
  align-items: center;
  justify-content: center;
  border: 1px solid #e6e8eb;
  background-color: #fff;
  border-radius: 4px;
  font-size: 18px;

  &:hover {
    cursor: pointer;
  }
`
